import { Grid2 } from "@mui/material";
import TableCell from "../../CertificateTable/TableCell";
import TestRecord from "../TestRecord";
import { stringToHtml } from "../../../helpers/string";


const ProductRow = ({ product, company }) => {
  const records = [...(product.test_records || [])];

  records.sort((recordA, recordB) => {
    return + new Date(recordB.testDate || new Date()) - new Date(recordA.testDate || new Date());
  });

  return (
    <Grid2 container size={12}>
      <TableCell bold size={3} clearBorderTop center>{product.product_type?.productTypeName}</TableCell>
      <TableCell size={3} clearBorderTop clearBorderLeft center html={stringToHtml(product.productName || '')} />
      <Grid2 container size={6}>
        {
          records.map((record) => (
            <TestRecord testRecord={record} key={record.id} company={company} />
          ))
        }
      </Grid2>
    </Grid2>
  )
}

export default ProductRow;